import React from 'react';
import Layout from '../components/Layout/Layout';
import placementRecordsPdf from '../images/Placement cell.pdf';

const PlacementRecordsPage = () => {
  return (
    <Layout>
      <div id="placement-records" className="page-container" style={{ maxWidth: '1000px', fontSize: '0.90rem', margin: '40px auto', padding: '0 20px', minHeight: '300px' }}>
        
        <h2 style={{ color: '#004d99', borderBottom: '2px solid #004d99', paddingBottom: '10px', marginBottom: '30px', textAlign: 'center', fontSize: '2.2rem', fontWeight: 'bold' }}>
          Placement Records
        </h2>
        
        <div style={{ backgroundColor: '#f0f8ff', border: '1px solid #e1f0ff', padding: '40px', borderRadius: '8px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
          <h3 style={{ color: '#004d99', textAlign: 'center', marginBottom: '30px', fontSize: '1.8rem', fontWeight: 'bold' }}>
            Embedded Placement Records Document
          </h3>
          
          <iframe 
            src={placementRecordsPdf} 
            width="100%" 
            height="800px" 
            title="Placement Records Document" 
            style={{ border: 'none', backgroundColor: '#333', borderRadius: '4px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }} 
          />
        </div>

      </div>
    </Layout>
  );
};

export default PlacementRecordsPage;
